<script lang="ts">
	//Design system components
	import { ToggleV2 } from '@Shelly/shelly-design-system';
	//Helpers
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	//Components
	import IrrigationConfirmModal from 'src/components/XT1/Irrigation/IrrigationConfirmModal.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type {
		TemplateService,
		VCInterfaceStatus,
		VirtualComponentInterface,
	} from 'src/types/VirtualComponents';

	let className = '';
	export { className as class };

	export let device: Device;
	export let statuses: VCInterfaceStatus[];
	export let setting: string;
	export let title: string;
	export let confirmModal: IrrigationConfirmModal = null;

	let value = false;
	let targetLock = false;
	let waitForResponse = false;
	let component: VirtualComponentInterface = null;

	const onSettingChange = (_statuses: VCInterfaceStatus[]) => {
		let _value = false;
		const templateService: TemplateService = getTemplateService(device);
		if (templateService?.settings?.[setting] != null) {
			_value = templateService.settings[setting] || false;
		} else {
			component = templateService.components.find((i) => i.config?.role == setting);
			_value = component?.status?.value || false;
		}
		if (!waitForResponse && !targetLock && value !== _value) {
			value = _value;
		}
		if (targetLock && value == _value) {
			targetLock = false;
		}
	};

	const saveValue = async () => {
		const _value = !value;
		if (confirmModal && !(await confirmModal.confirm())) {
			value = _value;
			targetLock = false;
			return;
		}
		waitForResponse = true;
		let res: SettingRequest;
		if (component) {
			res = await gen2Request(device, `${component.type}.set`, {
				id: component.config.id,
				value: _value,
			});
		} else {
			res = await gen2Request(device, 'Service.SetConfig', {
				id: 0,
				config: {
					[`${setting}`]: _value,
				},
			});
		}
		if (res?.isok) {
			targetLock = true;
			value = _value;
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: onSettingChange(statuses);
</script>

<ToggleV2
	size="m"
	class={className}
	disabled={waitForResponse}
	checked={value}
	on:click={saveValue}
	id="toggle-o23fmof"
>
	{title}
</ToggleV2>
